import { OpusJobsEffects } from './opus-jobs.effects';

export const effects: any[] = [OpusJobsEffects];

export * from './opus-jobs.effects';
